import { Button } from "components/Button";
import { Header } from "components/Header";
import { InputFormField } from "components/InputFormField";
import { Loading } from "components/Loading";
import { PlaceHolderNotExists } from "components/PlaceholderNotExists";
import { TableModifiedCards } from "components/TableModified/TableModifiedCards";
import { TableModifiedFilters } from "components/TableModified/TableModifiedFilters";
import { TableModifiedPagination } from "components/TableModified/TableModifiedPagination";
import { TableModifiedTable } from "components/TableModified/TableModifiedTable";
import React from "react";
import { useHistory } from "react-router-dom";
import { useTracksTable } from "./useTracksTable";
import { Container, TableSearchTracks } from "./styles";
import { useParams } from "react-router-dom";

const tableHead = [
  "Nome", 
  "Descrição", 
  "Cor", 
  "Data de Criação"
];

export const TracksTable: React.FC = () => {
  const {
    loading,
    error,
    properties,
    trackRows,
    tracksCount,
    searchText,
    tableFilters,
    searchTextFormRef,
    pageNumber,
    tracksPerPage,
    handleSearchTextFormSubmit,
    handleFilterChange,
    handleFilterRemove,
    handleSearchTextRemove,
    handlePageSelected,
    handleRowsPerPageChange,
    tracks,
    getTracks,
  } = useTracksTable();

  const { push } = useHistory();
  const { id: eventId } = useParams<{ id: string }>();

  const handleCreateTrack = () => {
    push(`/events/${eventId}/track/create`);
  };

  const handleEditTrack = (track: any) => {
    push(`/events/${eventId}/track/${track.trackId}/edit`);
  };





  return (
    <Container>
      <div>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'end', justifyContent: 'space-between', marginBottom: "1rem" }}>
          <TableSearchTracks
            className="table-search-tracks"
            onSubmit={handleSearchTextFormSubmit}
            ref={searchTextFormRef}
            style={{ flex: 1 }}
          >
            <InputFormField 
              label="Buscar tracks" 
              autoFocus={true} 
              name="searchText" 
              marginBotton={"0"} 
              backGround={"white"} 
              defaultValue={searchText}
              block={true} 
            />
            <Button 
              label="Buscar" 
              typeBtn="blue"
              type="submit"
              block={false} 
            />
          </TableSearchTracks>
          
          <Button 
            label="Criar track" 
            typeBtn="blue"
            onClick={handleCreateTrack}
            block={false} 
          />
        </div>
      </div>
      
      <TableModifiedFilters
        filters={tableFilters}
        searchTextFilter={searchText}
        onFilterChange={handleFilterChange}
        onFilterRemove={handleFilterRemove}
        onSearchTextRemove={handleSearchTextRemove}
      />
      
      {
        loading
        ? <Loading/>
        : error
          ? <PlaceHolderNotExists title="Erro ao se comunicar com o servidor"/>
          : <>
              <TableModifiedCards
                properties={properties}
              />
              <TableModifiedTable
                headerColumns={tableHead}
                rows={trackRows}
                onRowClick={(_, rowIndex) => {
                  if (tracks && tracks[rowIndex]) {
                    handleEditTrack(tracks[rowIndex]);
                  }
                }}
              />
            </>
      }
      
      {
        tracksCount > 0
        ? <TableModifiedPagination
            totalItemsCount={tracksCount}
            pageNumber={pageNumber}
            rowsPerPage={tracksPerPage}
            onPageSelected={handlePageSelected}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        : null
      }


    </Container>
  );
}; 